import moment from "moment";
import { DOWNLOAD_AMOUNT_CHANGED, CUSTOM_DATE_RANGE_CHANGED } from "../actions/types";
import { getPreviousDate } from "../actions";

const initialState = {
  downloadAmount: "30",
  startDate: getPreviousDate(moment().format()),
  endDate: moment().format(),
  customDownloadAmount:30,
  label: "Last 30 days"
};

export default (state = initialState, action) => {
  
  switch (action.type) {
      
    case DOWNLOAD_AMOUNT_CHANGED:
      let labelInfo =  action.label;
      if(action.label === "Custom date range (30 Day minimum)") {
        labelInfo = `${moment(state.startDate).format("MM/DD/YY")} - ${moment(state.endDate).format("MM/DD/YY")}`;
      }
      return {
        ...state,
        downloadAmount: action.payload,
        label: labelInfo,
        customDownloadAmount:30
      };
      
    case CUSTOM_DATE_RANGE_CHANGED:
      let numberOfDays = 30;
      let label = `${moment(state.startDate).format("MM/DD/YY")} - ${moment(state.endDate).format("MM/DD/YY")}`;
      if("startDate" === action.dateType) {
        numberOfDays = moment.duration(moment(state.endDate,"YYYY-MM-DD").diff(moment(action.payload.startDate, "YYYY-MM-DD"))).asDays();
        label = `${moment(action.payload.startDate).format("MM/DD/YY")} - ${moment(state.endDate).format("MM/DD/YY")}`;
      }
      else if("endDate" === action.dateType) {
        numberOfDays = moment.duration(moment(action.payload.endDate,"YYYY-MM-DD").diff(moment(state.startDate, "YYYY-MM-DD"))).asDays();
        label = `${moment(state.startDate).format("MM/DD/YY")} - ${moment(action.payload.endDate).format("MM/DD/YY")}`;
      }
  
      return { ...state,
         ...action.payload,
         customDownloadAmount: numberOfDays,
         label
      };
    default:
      return state;
  }
};
